import { Box } from '@mui/material'
import { Provider, inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import {
  isDealer,
  isLooker,
  isOperator,
} from '../../../../../services/AccountService'
import AddServiceRequestForm from '../CreateServiceDrawer/AddServiceRequestForm'
import ServiceInstallationData from './ServiceInstallationData'

const SubscriberData = ({
  serviceStore,
  operatorStore,
  preventEdit,
  isReportStatus,
}) => {
  const [isEdit, setIsEdit] = useState(false)
  const { currentServiceData } = serviceStore
  useEffect(() => {
    serviceStore?.toggleDisabledBtnSubmitRequest(isEdit)
  }, [isEdit])

  const getOnEdit = () => {
    if (!isLooker()) {
      return isOperator() && operatorStore?.selectedTab === 3
        ? currentServiceData?.isTakenByMe
        : currentServiceData?.isDataEditable
    }
  }

  return (
    <Box>
      {isEdit && !preventEdit ? (
        <Provider serviceStore={serviceStore}>
          <AddServiceRequestForm
            alwaysShow={true}
            onEdit={true}
            setIsEdit={setIsEdit}
            isEdit={isEdit}
            withoutAdditionalInfo={isDealer()}
            isReportStatus={isReportStatus}
          />
        </Provider>
      ) : (
        <ServiceInstallationData
          serviceStore={serviceStore}
          setIsEdit={setIsEdit}
          isEdit={isEdit}
          defaultOpenState={true}
          onEdit={!preventEdit && getOnEdit()}
          serviceOrder={currentServiceData}
          withoutInstallationDate={true}
        />
      )}
    </Box>
  )
}

export default inject('serviceStore')(observer(SubscriberData))
